<div class="products-resume-wrapper">

  <!-- Header fijo -->
  <div class="cart-header-row">
    <p class="cart-title">Carrito</p>
    <div class="cart-header-actions" *ngIf="cartUser?.cart_lines?.length > 0">
      <button class="btn-cart-action btn-clean" (click)="cleanCart()" title="Limpiar carrito">
        <fa-icon [icon]="faCartXMark"></fa-icon>
      </button>
      <button class="btn-cart-action btn-promo-action" *ngIf="!hasPromoCode"
        (click)="openPromoDialog()" title="Añadir código promocional">
        <fa-icon [icon]="faTag"></fa-icon>
      </button>
      <button class="btn-cart-action btn-save-reservation" (click)="saveAsReservation()" title="Guardar como reserva">
        <fa-icon [icon]="faBookmark"></fa-icon>
      </button>
    </div>
  </div>

  <div class="resume-events-wrapper px-4 pb-4">

    <!-- Cart lines -->
    <div *ngIf="cartUser?.cart_lines?.length > 0" style="border-top: 1px solid #D6D6D6;">
      <div *ngFor="let group of groupedCartLines; trackBy: trackByGroup" class="event-group-wrapper">

        <div class="event-group-header" (click)="toggleGroup(group.groupKey)">
          <div class="event-group-img">
            <img *ngIf="group.event?.image_url" [src]="urlImages + group.event.image_url" />
            <div class="event-group-img-placeholder" *ngIf="!group.event?.image_url">
              <fa-icon [icon]="faTicket"></fa-icon>
            </div>
          </div>
          <div class="event-group-info">
            <span class="event-group-title">{{ group.event?.title }}</span>
            <span class="event-group-session">
              <fa-icon [icon]="faCalendar"></fa-icon>
              {{ group.session?.start_date | date:'dd MMM yyyy · HH:mm':'+0000' }}h
            </span>
            <span class="event-group-quantity">
              {{ group.quantityTotal }} entrada{{ group.quantityTotal > 1 ? 's' : '' }}
            </span>
          </div>
          <span class="event-group-total">{{ formatNumber(group.total) }}</span>
          <fa-icon class="event-group-chevron" [icon]="faChevron" [class.rotated]="!group.expanded"></fa-icon>
        </div>

        <div *ngIf="group.expanded">
          <div *ngFor="let cart_line of group.lines; index as i; trackBy: trackByLine"
              class="resume-event-wrapper py-2">
            <app-resume-event-card (ticketRemoved)="manejarEvento($event)"
              [cartLine]="cart_line" [position]="i">
            </app-resume-event-card>
          </div>
        </div>

      </div>
    </div>

    <div class="empty-cart" *ngIf="cartUser?.cart_lines?.length == 0">
      <fa-icon [icon]="faTicket" class="empty-cart-icon"></fa-icon>
      <p class="empty-cart-title">Carrito vacío</p>
      <p class="empty-cart-subtitle">Selecciona un evento y añade entradas para empezar</p>
    </div>

  </div>

  <!-- Footer -->
  <div class="cart-footer" *ngIf="cartUser?.cart_lines?.length >= 1">

    <!-- Subtotals -->
    <div class="cart-totals"
         *ngIf="cartUser?.total_order?.discount_total > 0 || hasPromoCode || (cartUser?.total_order?.fee_total ?? cartService.getPriceCart().fees) > 0">
      <div class="totals-row" *ngIf="cartUser?.total_order?.discount_total > 0">
        <span class="totals-label">Subtotal</span>
        <span class="totals-value">{{ formatNumber(cartUser.total_order.subtotal_without_discount) }}</span>
      </div>

      <!-- Fila descuento desplegable -->
      <div *ngIf="cartUser?.total_order?.discount_total > 0">
        <div class="totals-row totals-row--discount totals-row--expandable"
             (click)="discountExpanded = !discountExpanded">
          <span class="totals-label">
            Descuentos
            <fa-icon [icon]="faChevron" class="totals-chevron" [class.rotated]="discountExpanded"></fa-icon>
          </span>
          <span class="totals-value">-{{ formatNumber(cartUser.total_order.discount_total) }}</span>
        </div>

        <div class="discount-pills" *ngIf="discountExpanded">
          <div class="discount-pill discount-pill--auto" *ngFor="let d of appliedDiscounts">
            <fa-icon [icon]="faPercent" class="pill-icon"></fa-icon>
            <span class="pill-name">{{ d.public_name }}</span>
            <span class="pill-badge">Auto</span>
            <span class="pill-amount">-{{ formatNumber(d.discount_total) }}</span>
          </div>
          <div class="discount-pill discount-pill--promo" *ngFor="let promo of promoCodeDiscounts">
            <fa-icon [icon]="faTag" class="pill-icon"></fa-icon>
            <span class="pill-name">{{ promo.public_name }}</span>
            <span class="pill-amount">-{{ formatNumber(promo.amount) }}</span>
            <button class="btn-remove-promo" (click)="removePromo()" [disabled]="promoRemoving" title="Eliminar código">
              <i class="fa-regular fa-times"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Promo aplicada sin otros descuentos (sin subtotal que desplegar) -->
      <div *ngIf="hasPromoCode && !(cartUser?.total_order?.discount_total > 0)">
        <div class="discount-pills">
          <div class="discount-pill discount-pill--promo" *ngFor="let promo of promoCodeDiscounts">
            <fa-icon [icon]="faTag" class="pill-icon"></fa-icon>
            <span class="pill-name">{{ promo.public_name }}</span>
            <span class="pill-amount">-{{ formatNumber(promo.amount) }}</span>
            <button class="btn-remove-promo" (click)="removePromo()" [disabled]="promoRemoving" title="Eliminar código">
              <i class="fa-regular fa-times"></i>
            </button>
          </div>
        </div>
      </div>

      <div class="totals-row" *ngIf="(cartUser?.total_order?.fee_total ?? cartService.getPriceCart().fees) > 0">
        <span class="totals-label">Comisión</span>
        <span class="totals-value">{{ formatNumber(cartUser?.total_order?.fee_total ?? cartService.getPriceCart().fees) }}</span>
      </div>
    </div>

    <!-- COBRAR button -->
    <div class="btn-cobrar-wrapper">
      <div class="btn-cobrar" (click)="pay()">
        <span class="btn-cobrar-label">COBRAR</span>
        <span class="btn-cobrar-detail">
          {{ totalCartQuantity }} entrada{{ totalCartQuantity > 1 ? 's' : '' }}
          &nbsp;·&nbsp;
          {{ formatNumber(cartUser?.total_order?.total) }}
        </span>
      </div>
    </div>

    <!-- COBRAR disabled -->
    <ng-template #payDisabled>
      <div class="btn-cobrar-wrapper">
        <div class="btn-cobrar btn-cobrar--disabled">
          <span class="btn-cobrar-label">COBRAR</span>
          <span class="btn-cobrar-detail">0 entradas</span>
        </div>
      </div>
    </ng-template>

  </div>

  <div class="cart-footer" *ngIf="!cartUser?.cart_lines?.length">
    <div class="btn-cobrar-wrapper">
      <div class="btn-cobrar btn-cobrar--disabled">
        <span class="btn-cobrar-label">COBRAR</span>
        <span class="btn-cobrar-detail">0 entradas</span>
      </div>
    </div>
  </div>

</div>
